import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { translate, Translate } from 'react-i18nify'
import {
    addClass,
    checkForEmptyFields,
    getErrorFields,
    getErrorMessages,
    isRequired,
    removeClass,
} from '../../helpers'
import { diffProfileItems, editProfileItem, fetchStudyLevels } from '../../store/actions/user'

import Actions from '../Actions/Actions'
import Alert from '../Alert/Alert'
import 'react-dates/lib/css/_datepicker.css'
import Select from 'react-select'
import Datepicker from '../Datepicker/Datepicker'

var moment = require('moment')

let otherId = -1,
    map

/**
 * @property: className: PropTypes.string.isRequired,
 * @property: useOutsideActions: boolean
 * @property: onSave: PropTypes.func.isRequired,
 * @property: onCancel: PropTypes.func.isRequired,
 * @property: dispatch: PropTypes.func.isRequired,
 * @property: studies: PropTypes.array.isRequired,
 * @property: edit: PropTypes.object
 */
class FormStudies extends Component {
    constructor(props) {
        super(props)

        let study_options = props.studies.map((s) => ({ value: s.id, label: s.name }))
        let study_level_options = props.user.study_levels.map((l) => ({
            value: l.id,
            label: l.name,
        }))

        let requiredFields = ['location', 'start_date', 'end_date', 'study_level_id', 'study_id']

        if (this.props.edit) {
            let study = this.props.edit

            let end = null
            if (study.end_date && study.end_date.length > 0) {
                end = moment(study.end_date)
            }

            let selected_study = study_options.find((so) => so.value === study.study_id)

            this.state = {
                id: this.props.isFirstTime ? -1 : this.props.id, // if not first time, use the id from HighestStudy
                study_id: selected_study || '',
                study_name_other: study.study_name_other,
                location: study.institute_name,
                start_date: study.start_date ? moment(study.start_date) : moment(),
                study_level_id:
                    study_level_options.find((so) => so.value === study.study_level_id) || '',
                end_date: end,
                finished: study.finished,
                edit: this.props.isFirstTime ? false : true, // if not first time, update the existing study, else create a new one
                shouldSelectOther: false,
                loading: false,
                errors: [],
                fields: [],
                study_level_options,
                study_options,
                requiredFields: requiredFields.concat(
                    selected_study && selected_study.label === 'Overig' ? ['study_name_other'] : [],
                ),
            }
        } else {
            this.state = {
                id: -1,
                study_id: '',
                study_name_other: '',
                location: '',
                start_date: moment(),
                end_date: moment(),
                study_level_id: undefined,
                finished: 1,
                error: '',
                edit: false,
                shouldSelectOther: false,
                loading: false,
                errors: [],
                fields: [],
                study_level_options,
                study_options,
                requiredFields,
            }
        }
    }

    componentDidMount() {
        this.props.dispatch(fetchStudyLevels())
    }

    handleStartDate(date) {
        this.setState({
            start_date: date,
        })
    }

    handleEndDate(date) {
        this.setState({
            end_date: date,
        })
    }

    getDateClassNames(item, field) {
        let c = 'form__input--date has-value'

        if (this.state.fields.indexOf(field) != -1) {
            c += ' error'
        }

        return c
    }

    handleChange(value, key, changeClass = true) {
        let obj = {}
        obj[key] = value.target.value

        this.setState(obj)

        if (changeClass) {
            if (value.target.value.length > 0) {
                addClass(value.currentTarget, 'has-value')
            } else {
                removeClass(value.currentTarget, 'has-value')
            }
        }
    }

    handleStudyChange(value, key, changeClass = true) {
        otherId = this.state.study_options.find((s) => s.label === 'Overig').id

        if (value.value !== otherId) {
            this.setState((s) => ({
                study_name_other: '',
                requiredFields: s.requiredFields.filter((rf) => rf !== 'study_name_other'),
            }))
        } else {
            this.setState((s) => ({
                requiredFields: s.requiredFields.concat(['study_name_other']),
            }))
        }

        this.handleChange({ target: { value: value } }, key, changeClass)
    }

    handleStudyOtherChange(value, key, changeClass = true) {
        otherId = this.state.study_options.find((s) => s.label === 'Overig')

        if (value.target.value.length > 0) {
            this.setState((s) => ({
                study_id: otherId,
                requiredFields: s.requiredFields.concat(['study_name_other']),
            }))
        }

        this.handleChange(value, key, changeClass)
    }

    cancel() {
        if (this.state.loading) {
            return
        }

        this.state = {
            errors: [],
            fields: [],
            shouldSelectOther: false,
            id: -1,
            study_id: null,
            study_name_other: '',
            location: '',
            start: '',
            end: '',
            finished: 1,
            error: '',
            edit: false,
            loading: false,
        }
        this.props.onCancel()
    }

    save() {
        if (this.state.loading) {
            return
        }
        let empty = checkForEmptyFields(this.state)
        if (empty.length > 0) {
            this.addErrors([translate('errors.empty_field')])
            this.addErrorFields(empty)
            return
        }
        this.setState({
            loading: true,
        })

        let study_name_other = this.state.study_name_other,
            location = this.state.location,
            start = this.state.start_date,
            end = this.state.end_date,
            finished = this.state.finished,
            study_level_id = this.state.study_level_id || this.props.user.study_levels[0].id,
            study_id = this.state.study_id

        if (end != null && end != undefined) {
            end = end.format('YYYY-MM-DD')
        }

        if (start != null && start != null) {
            start = start.format('YYYY-MM-DD')
        }

        let study = {
            study_name_other: study_name_other,
            institute_name: location,
            start_date: start,
            end_date: end,
            finished: finished,
            current: finished == 1 ? 0 : 1,
            study_id: study_id.value,
            study_level_id: study_level_id.value,
        }

        if (this.state.id != -1) {
            study.id = this.state.id
        }

        if (this.state.edit && !this.props.isFirstTime) {
            this.props.dispatch(
                editProfileItem(
                    'studies',
                    study,
                    this.props.auth,
                    () => this.onSuccess(),
                    (status, error) => this.onError(status, error),
                ),
            )
        } else {
            this.props
                .dispatch(
                    diffProfileItems(
                        'studies',
                        [study],
                        [],
                        this.props.auth,
                        () => {
                            this.onSuccess()
                        },
                        (s, o) => {
                            this.onError(s, o)
                        },
                    ),
                )
                .then((ids) => {
                    // get id of the newly created study and update id in parent component
                    this.props.diplomaFilled(ids[0])
                    // console.log('FormStudies got id of the study: ', ids[0])
                })
        }
    }

    onError(status, object) {
        map = {
            study_name_other: translate('profile.education_different'),
            institute_name: translate('profile.education_location'),
            study_id: translate('profile.study'),
            start_date: translate('profile.education_from'),
            end_date: translate('profile.education_until'),
            study_level_id: translate('profile.label_study_level'),
        }
        this.setState(
            {
                errors: [],
                fields: [],
                loading: false,
            },
            () => {
                if (object.hasOwnProperty('errors')) {
                    let messages = getErrorMessages(object.errors, map)
                    var fields = getErrorFields(object.errors)

                    this.addErrors(messages)
                    this.addErrorFields(fields)
                }
            },
        )
    }

    addErrors(errors) {
        if (this.props.showErrors) {
            this.props.showErrors(errors)
        } else {
            this.setState({
                errors: errors,
            })
        }
    }

    addErrorFields(fields) {
        this.setState({
            fields: fields,
        })
    }

    getClassNames(item, field) {
        let c = ''

        if (item != null && item != '' && item.length > 0) {
            c += ' has-value'
        }

        if (this.state.fields.indexOf(field) != -1) {
            c += ' error'
        }

        return c
    }

    onSuccess() {
        console.log('success saving education')
        this.setState({
            errors: [],
            fields: [],
            shouldSelectOther: false,
            id: -1,
            study_id: null,
            study_name_other: '',
            location: '',
            start: '',
            end: '',
            finished: 1,
            error: '',
            edit: false,
            loading: false,
        })
        this.props.onSave()
    }

    getSaveClasses() {
        let c = 'actions__action--save'

        if (this.state.loading) {
            c += ' is-loading'
        }

        return c
    }

    render() {
        const verified = this.props.edit ? !!this.props.edit.verified : false

        return (
            <form
                className={this.props.className}
                onKeyDown={(e) => {
                    if (e.keyCode === 13) {
                        //Enter pressed
                        this.save()
                    }
                }}
            >
                <fieldset className="form__fieldset">
                    {this.state.errors && this.state.errors.length > 0 && (
                        <Alert type="alert--error alert--simple">
                            <ul>
                                {this.state.errors.map(function (value) {
                                    return <li key={value}>{value}</li>
                                })}
                            </ul>
                        </Alert>
                    )}

                    <div className={'form__item' + isRequired('study_id', this.state)}>
                        <i className="form__icon icons icon-graduation" />
                        <Select
                            className={
                                'select--alt' +
                                (this.props.darkMode ? '-black' : '') +
                                this.getClassNames(this.state.study_id, 'study_id')
                            }
                            classNamePrefix="select"
                            value={this.state.study_id}
                            onChange={(value) => this.handleStudyChange(value, 'study_id', false)}
                            tabIndex="1"
                            disabled={verified}
                            isSearchable={true}
                            options={this.state.study_options}
                            placeholder={translate('profile.studies_placeholder')}
                            id={'study'}
                        ></Select>
                        <label className="form__label" htmlFor="study">
                            <Translate value="profile.study" />
                        </label>
                    </div>
                    <div className={'form__item' + isRequired('study_name_other', this.state)}>
                        <input
                            className={
                                'form__input--text' +
                                this.getClassNames(this.state.study_name_other, 'study_name_other')
                            }
                            type="text"
                            id="study_name"
                            value={this.state.study_name_other}
                            onChange={(value) =>
                                this.handleStudyOtherChange(value, 'study_name_other', false)
                            }
                            autoFocus
                            tabIndex="2"
                            disabled={verified}
                        />
                        <label className="form__label" htmlFor="study_name">
                            <Translate value="profile.education_different" />
                        </label>
                    </div>
                    <div className={'form__item' + isRequired('study_level_id', this.state)}>
                        <i className="form__icon icons icon-graduation" />
                        <Select
                            className={
                                'select--alt' +
                                (this.props.darkMode ? '-black' : '') +
                                this.getClassNames(this.state.study_level_id, 'study_level_id')
                            }
                            classNamePrefix="select"
                            value={this.state.study_level_id}
                            onChange={(value) =>
                                this.handleChange(
                                    { target: { value: value } },
                                    'study_level_id',
                                    false,
                                )
                            }
                            tabIndex="1"
                            options={this.state.study_level_options}
                            placeholder={translate('profile.study_levels_placeholder')}
                            id={'study_level'}
                        ></Select>
                        <label className="form__label" htmlFor="study_level">
                            <Translate value="profile.label_study_level" />
                        </label>
                    </div>
                    <div className={'form__item' + isRequired('location', this.state)}>
                        <input
                            className={
                                'form__input--text' +
                                this.getClassNames(this.state.location, 'location')
                            }
                            type="text"
                            id="study_location"
                            value={this.state.location}
                            onChange={(value) => this.handleChange(value, 'location')}
                            tabIndex="3"
                            disabled={verified}
                        />
                        <label className="form__label" htmlFor="study_location">
                            <Translate value="profile.education_location" />
                        </label>
                    </div>
                    <div className={'form__item' + isRequired('start_date', this.state)}>
                        <i className="form__icon icons icon-calendar" />
                        <Datepicker
                            date={this.state.start_date}
                            onDateChange={(date) => this.handleStartDate(date)}
                            classNames={this.getDateClassNames(this.state.start_date, 'start_date')}
                            id={'study_from'}
                        />
                        <label className="form__label" htmlFor="study_from">
                            <Translate value="profile.education_from" />
                        </label>
                    </div>
                    <div className={'form__item' + isRequired('end_date', this.state)}>
                        <i className="form__icon icons icon-calendar" />
                        <Datepicker
                            date={this.state.end_date}
                            onDateChange={(date) => this.handleEndDate(date)}
                            classNames={this.getDateClassNames(this.state.end_date, 'end_date')}
                            id={'study_until'}
                        />
                        <label className="form__label" htmlFor="study_until">
                            <Translate value="profile.education_until" />
                        </label>
                    </div>
                    <div className={'form__item' + isRequired('finished', this.state)}>
                        <label className="form__top_label">Diploma behaald?</label>
                        <div className="form__radio">
                            <input
                                type="radio"
                                name="radio_styled"
                                id="study_graduated_yes"
                                className="form__radio__input"
                                checked={this.state.finished == 1}
                                onChange={(value) => this.handleChange(value, 'finished', false)}
                                value="1"
                                tabIndex="6"
                                disabled={verified}
                            />
                            <label className="form__radio__label" htmlFor="study_graduated_yes">
                                <Translate value="profile.graduated_yes" />
                            </label>
                        </div>
                        <div className="form__radio">
                            <input
                                type="radio"
                                name="radio_styled"
                                id="study_graduated_no"
                                className="form__radio__input"
                                checked={this.state.finished != 1}
                                onChange={(value) => this.handleChange(value, 'finished', false)}
                                value="0"
                                tabIndex="7"
                                disabled={verified}
                            />
                            <label className="form__radio__label" htmlFor="study_graduated_no">
                                <Translate value="profile.graduated_no" />
                            </label>
                        </div>
                    </div>
                </fieldset>
                {this.props.showActions && (
                    <Actions>
                        <Link
                            className="actions__action--cancel"
                            onClick={() => {
                                this.cancel()
                            }}
                            tabIndex="8"
                        >
                            <Translate value="profile.cancel" />
                        </Link>
                        <Link
                            className={this.getSaveClasses()}
                            onClick={() => this.save()}
                            tabIndex="9"
                        >
                            <Translate value="profile.save" />
                        </Link>
                    </Actions>
                )}
            </form>
        )
    }
}

FormStudies.propTypes = {
    className: PropTypes.string.isRequired,
    onSave: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
    studies: PropTypes.array.isRequired,
    edit: PropTypes.object,
    showActions: PropTypes.bool,
}

function mapStateToProps(state) {
    const { auth, user } = state

    return {
        auth,
        user,
    }
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, null, null, { forwardRef: true })(FormStudies)
